<template>
  <div v-if="show" class="confirm-modal-backdrop" @click.self="handleCancel">
    <div class="confirm-modal-dialog">
      <div class="confirm-modal-content">
        <div class="confirm-modal-header">
          <h5 class="confirm-modal-title">
            <i :class="iconClass"></i>
            {{ title }}
          </h5>
          <button type="button" class="confirm-btn-close" @click="handleCancel">
            <i class="bi bi-x"></i>
          </button>
        </div>
        <div class="confirm-modal-body">
          <p>{{ message }}</p>
        </div>
        <div class="confirm-modal-footer">
          <button type="button" class="confirm-btn confirm-btn-secondary" @click="handleCancel">
            Cancel
          </button>
          <button type="button" :class="`confirm-btn ${dangerButton ? 'confirm-btn-danger' : 'confirm-btn-primary'}`" @click="handleConfirm">
            {{ confirmText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfirmModal',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Confirm Action'
    },
    message: {
      type: String,
      required: true
    },
    confirmText: {
      type: String,
      default: 'Confirm'
    },
    dangerButton: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: 'question'
    }
  },
  computed: {
    iconClass() {
      const icons = {
        question: 'bi bi-question-circle-fill',
        warning: 'bi bi-exclamation-triangle-fill',
        danger: 'bi bi-exclamation-octagon-fill',
        info: 'bi bi-info-circle-fill'
      };
      return icons[this.icon] || icons.question;
    }
  },
  methods: {
    handleConfirm() {
      this.$emit('confirm');
    },
    handleCancel() {
      this.$emit('cancel');
    }
  }
};
</script>

<style scoped>
.confirm-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999999;
  animation: confirmFadeIn 0.15s ease;
}

@keyframes confirmFadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.confirm-modal-dialog {
  max-width: 500px;
  width: 90%;
  animation: confirmSlideIn 0.2s ease;
  position: relative;
  z-index: 1000000;
}

@keyframes confirmSlideIn {
  from {
    transform: translateY(-50px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.confirm-modal-content {
  background: var(--bg-card);
  border-radius: 8px;
  border: 1px solid var(--border-default);
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.4);
}

.confirm-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid var(--border-default);
}

.confirm-modal-title {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: var(--text-primary);
  display: flex;
  align-items: center;
  gap: 10px;
}

.confirm-modal-title i {
  font-size: 24px;
  color: #f59e0b;
}

.confirm-btn-close {
  background: transparent;
  border: none;
  color: #9ca3af;
  font-size: 24px;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.confirm-btn-close:hover {
  background-color: var(--form-bg);
  color: var(--text-primary);
}

.confirm-modal-body {
  padding: 24px;
}

.confirm-modal-body p {
  margin: 0;
  color: #e5e7eb;
  font-size: 15px;
  line-height: 1.6;
}

.confirm-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid var(--border-default);
}

.confirm-btn {
  padding: 10px 20px;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 14px;
  border: none;
}

.confirm-btn-secondary {
  background-color: var(--bg-card);
  color: var(--text-primary);
  border: 1px solid var(--border-default);
}

.confirm-btn-secondary:hover {
  background-color: var(--bg-card);
  border-color: var(--border-hover);
}

.confirm-btn-primary {
  background-color: var(--primary-start);
  color: var(--text-primary);
  border: 1px solid var(--primary-start);
}

.confirm-btn-primary:hover {
  background-color: hsl(243, 91%, 64%);
}

.confirm-btn-danger {
  background-color: #ef4444;
  color: var(--text-primary);
  border: 1px solid #ef4444;
}

.confirm-btn-danger:hover {
  background-color: #dc2626;
}
</style>

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid var(--border-default);
}

.modal-title {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: var(--text-primary);
  display: flex;
  align-items: center;
  gap: 10px;
}

.modal-title i {
  font-size: 24px;
  color: #f59e0b;
}

.btn-close {
  background: transparent;
  border: none;
  color: #9ca3af;
  font-size: 24px;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.btn-close:hover {
  background-color: var(--form-bg);
  color: var(--text-primary);
}

.modal-body {
  padding: 24px;
}

.modal-body p {
  margin: 0;
  color: #e5e7eb;
  font-size: 15px;
  line-height: 1.6;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid var(--border-default);
}

.btn {
  padding: 10px 20px;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 14px;
  border: none;
}

.btn-secondary {
  background-color: var(--bg-card);
  color: var(--text-primary);
  border: 1px solid var(--border-default);
}

.btn-secondary:hover {
  background-color: var(--bg-card);
  border-color: var(--border-hover);
}

.btn-primary {
  background-color: var(--primary-start);
  color: var(--text-primary);
  border: 1px solid var(--primary-start);
}

.btn-primary:hover {
  background-color: hsl(243, 91%, 64%);
}

.btn-danger {
  background-color: #ef4444;
  color: var(--text-primary);
  border: 1px solid #ef4444;
}

.btn-danger:hover {
  background-color: #dc2626;
}
</style>
